import React, { useState } from "react";
import ReactHtmlParser from "react-html-parser";
import { Link } from "react-router-dom";
import FileAction from "./FileAction";
import Comments from "./Comments";
import { CommentResource } from "../../../../stores/CommentStore/Types";

interface Props {
  selectedAnswer: any;
  question: any;
  answer: any;
  updateSelectedAnswer: (val: any) => void;
  submitAnswer: (e) => void;
  submitting: boolean;
  loadingAnswer: boolean;
  comments: CommentResource[];
  currentUser: any;
  mode: string;
  search: string;
  enrolmentId: number;
}

const Opinion: React.FC<Props> = ({
  question,
  answer,
  selectedAnswer,
  updateSelectedAnswer,
  submitAnswer,
  submitting,
  loadingAnswer,
  comments,
  currentUser,
  mode,
  search,
  enrolmentId,
}) => {
  const [feedback, setFeedback] = useState("");

  const handleChange = (e) => {
    setFeedback("");
    updateSelectedAnswer(e.target.value);
  };

  const handleSubmit = (e) => {
    if (!selectedAnswer || !String(selectedAnswer).trim()) {
      e.preventDefault();
      setFeedback("Type an answer before submitting.");
      return;
    }

    submitAnswer(e);
  };

  const translation = question?.translations?.find(
    (t) => t.language === currentUser?.locale,
  );

  return (
    <>
      {question.uploader_type ? (
        <FileAction
          question={question}
          answer={answer}
          submitAnswer={submitAnswer}
          selectedAnswer={selectedAnswer}
          submitting={submitting}
          loadingAnswer={loadingAnswer}
          updateSelectedAnswer={updateSelectedAnswer}
          mode={mode}
          comments={comments}
          search={search}
          currentUser={currentUser}
          enrolmentId={enrolmentId}
        />
      ) : (
        <form className="q-card assignment-form">
          <div className="q-row">
            <span className="q-badge">Q</span>
            <div className="q-text">
              {ReactHtmlParser(
                translation?.formatted_description ||
                  question?.formatted_description,
              )}
            </div>
          </div>
          <div className="q-row q-answer">
            {(loadingAnswer || submitting) && (
              <div className="ui active inverted dimmer">
                <div className="ui text loader">Loading</div>
              </div>
            )}
            <span className="q-badge a">A</span>
            <div className="q-answer__body">
              {answer && (
                <p className="op-your">
                  {ReactHtmlParser(answer?.formatted_content)}
                </p>
              )}
              {!answer && (
                <>
                  <textarea
                    className="q-textarea"
                    placeholder="Type your answer, then submit..."
                    value={selectedAnswer}
                    onChange={handleChange}
                  />
                  <p className="q-hint">
                    Once you have shared your thought you will see what others
                    on this course think, and vote for the ones you find most
                    interesting.
                  </p>
                </>
              )}
            </div>
          </div>
          {!answer && (
            <div className="q-actions">
              <span className={`q-feedback ${feedback ? "no" : ""}`}>
                {feedback}
              </span>
              <button
                className={`btn btn-blue btn--compact ${
                  submitting ? "loading" : ""
                }`}
                type="submit"
                onClick={handleSubmit}
              >
                Submit answer
              </button>
            </div>
          )}

          {answer && answer.state == "pending" && (
            <div className="q-actions">
              <Link
                to={`/enrolments/${enrolmentId}/questions/${question.id}/answers/${answer.id}/votes`}
                className={`btn btn-blue btn--compact ${
                  submitting ? "loading" : ""
                }`}
              >
                Continue to votes
              </Link>
            </div>
          )}
          {answer && answer.state === "passed" && (
            <Comments
              comments={comments}
              answer={answer}
              currentUser={currentUser}
              search={search}
              enrolmentId={enrolmentId}
              questionId={question?.id}
            />
          )}
        </form>
      )}
    </>
  );
};

export default Opinion;
